// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i9-6";
export var emphasizeQuantity = "_i9-3";
export var flatBottomCorners = "_i9-5";
export var productImage = "_i9-0";
export var quantityContainer = "_i9-2";
export var tooltip = "_i9-1";
export var wrapAndEllipsesOverflow = "_i9-4";